export default __webpack_public_path__ + "landlord.en-us.1763532229688.json";